import { jsx } from "react/jsx-runtime";
import { isEditor } from "../../utils/isEditor.esm.js";
import RentVsBuyCalculator from "./RentVsBuyCalculator.esm.js";
const RentVsBuyCalculatorBlock = {
  Component: ({
    attrs
  }) => {
    const {
      purchasePrice,
      downPaymentPercent,
      monthlyRent,
      mortgageRate,
      regionId
    } = attrs;
    const attrValues = {
      purchasePrice,
      downPaymentPercent,
      monthlyRent,
      mortgageRate,
      regionId
    };
    return /* @__PURE__ */ jsx(RentVsBuyCalculator, { ...attrValues }, isEditor() ? JSON.stringify(attrValues) : void 0);
  },
  metadata: {
    version: "1.0",
    name: "constellation/rent-vs-buy-calculator",
    title: "Rent vs. Buy Calculator",
    description: "Calculate whether it is cheaper to rent or buy a home",
    icon: "calculator",
    keywords: ["rent", "buy", "calculator", "mortgage", "breakeven"],
    category: "Calculators",
    attributes: {
      purchasePrice: {
        type: "string",
        label: "Override Home Price",
        control: "text"
      },
      downPaymentPercent: {
        type: "string",
        label: "Override Down Payment %",
        control: "text"
      },
      monthlyRent: {
        type: "string",
        label: "Override Monthly Rent",
        control: "text"
      },
      mortgageRate: {
        type: "string",
        label: "Override Mortgage Rate %",
        control: "text"
      },
      regionId: {
        type: "string",
        label: "Region ID (city-level Zillow regionId for housing trends data)",
        control: "text"
      }
    }
  }
};
export {
  RentVsBuyCalculatorBlock as default
};
